import { useState } from "react";
import { toast } from "sonner";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";

export const OtpStep = ({ challenge, onSuccess, onBack }) => {
  const [code, setCode] = useState("");
  const [remember, setRemember] = useState(true);
  const [busy, setBusy] = useState(false);

  const verify = async (e) => {
    e?.preventDefault();
    if (code.length !== 6) return;
    setBusy(true);
    try {
      const { data } = await api.post("/auth/verify-otp", { challenge_id: challenge.challenge_id, code, remember_device: remember });
      onSuccess(data);
    } catch (err) {
      toast.error(errMsg(err));
      setCode("");
    } finally {
      setBusy(false);
    }
  };

  const resend = async () => {
    try {
      await api.post("/auth/resend-otp", { challenge_id: challenge.challenge_id });
      toast.success("A new code has been sent");
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <form onSubmit={verify} className="space-y-6" data-testid="otp-form">
      <p className="text-sm text-muted-foreground">We sent a 6-digit code to <strong className="text-foreground" data-testid="otp-email-hint">{challenge.email_hint}</strong>. It expires in 10 minutes.</p>
      <InputOTP maxLength={6} value={code} onChange={setCode} data-testid="otp-input" autoFocus>
        <InputOTPGroup>
          {[0, 1, 2, 3, 4, 5].map((i) => <InputOTPSlot key={i} index={i} className="h-14 w-12 text-lg" />)}
        </InputOTPGroup>
      </InputOTP>
      <label className="flex items-center gap-3 text-sm cursor-pointer">
        <Checkbox checked={remember} onCheckedChange={(v) => setRemember(!!v)} data-testid="otp-remember-checkbox" />
        Trust this device for 30 days (skip codes next time)
      </label>
      <button disabled={busy || code.length !== 6} className="btn-brand w-full disabled:opacity-50" data-testid="otp-verify-btn">{busy ? "Verifying..." : "Verify & continue"}</button>
      <div className="flex justify-between text-sm">
        <button type="button" onClick={onBack} className="text-muted-foreground hover:text-foreground" data-testid="otp-back-btn">Back</button>
        <button type="button" onClick={resend} className="font-semibold text-[#7c3aed]" data-testid="otp-resend-btn">Resend code</button>
      </div>
    </form>
  );
};
